/* eslint-disable no-param-reassign */
import { createStyledClone } from '@/services/print/svghelpers';

export default (metric, template) => {
    const { definition, label, chart } = template;
    chart.svg = createStyledClone({ selector: '.population-chart .content-container svg' });
    definition.text = `${metric.formatWithUnits(metric.proportionsInRanges[0].value)} of the ${metric.localName} population is over the age of 65 as compared to ${metric.formatWithUnits(metric.proportionsInRanges[0].compareValue)} in Alberta. ${metric.formatWithUnits(metric.proportionsInRanges[1].value)} is under the age of 18 as compared to ${metric.formatWithUnits(metric.proportionsInRanges[1].compareValue)} in Alberta.`;
    // chart.preserveAspectRatio = false;
    chart.x = 'w-0-1/4';
    chart.w = 'w-3-1/2';
    chart.h = 'h-3-1/2';
    label.h = 'h-0-1/2';
    template.h = 'h-4-1/2';
    return template;
};
